import ModalForm from 'assets/components/form/modalForm/ModalForm';
import ThemeModalFormDefault from 'assets/components/form/modalForm/themes/Theme.ModalForm.Default';
import Icon from 'assets/components/icon/Icon';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import TextInput from 'assets/components/inputs/text/TextInput';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import useApi from 'assets/hooks/api/useApi';
import { getLocales } from 'assets/locales/Locale';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';
import { compact } from 'lodash';
import PricingDistributionMasterTemplate from 'models/productManagement/pricingDistributionMasterTemplate/Model.PricingDistributionMasterTemplate';
import Distributor from 'models/sales/distributor/Model.Distributor';
import { usePricingDistributionTemplateProvider } from '../PricingDistributionTemplate.Hooks';

export default function PricingDistributionTemplateEdit() {
  const { lang } = getLocales();
  const { user } = useAuthStore();
  const { selected, pageRouter, saveApi, isDealerOrDistributor } = usePricingDistributionTemplateProvider();

  const distributorsApi = useApi({
    action: Distributor.list,
    wait: isDealerOrDistributor,
  });
  const masterTemplatesApi = useApi({
    action: PricingDistributionMasterTemplate.list,
  });

  return (
    <ModalForm<Api.Core.PricingDistributionTemplate.Save.IRequest>
      subcomponents={ThemeModalFormDefault}
      dependencyArray={[selected]}
      title={lang.pricingDistributionTemplate}
      default={
        selected?.toJSON() ??
        (!user?.distributorId
          ? {}
          : {
              distributorId: user?.distributorId,
            })
      }
      onCancel={pageRouter.updateParams}
      onSubmit={(data) =>
        saveApi.execute({
          ...data,
          keys: compact(data.keys),
        })
      }
      validation={(data, errors) => {
        if (!data.name) errors.name = lang.mustNotBeEmpty;
      }}
      render={({ form }) => (
        <FormWrapper>
          <TextInput
            name="name"
            label={lang.name}
            value={form.data.name}
            error={form.errors.name}
            onChange={form.update}
            icon={<Icon class="if-quill-pen" />}
          />
          <SelectInput
            name="distributorId"
            label={lang.distributor}
            data={distributorsApi?.payload?.data?.map((it) => it.displayInfo)}
            value={form.data.distributorId}
            error={form.errors.distributorId}
            onChange={({ distributorId }) => {
              const distributor = distributorsApi?.payload?.data?.find((d) => d.id === distributorId);
              form.update({
                distributor: distributor?.toJSON(),
                distributorId: distributor?.id,
              });
            }}
            icon={<Icon class="fas-globe" />}
          />

          <SelectInput
            name="masterKey"
            label={lang.pricingDistributionTemplates}
            data={masterTemplatesApi?.payload?.data?.map((it) => ({ id: it.name, title: it.name }))}
            value={form.data.keys ?? []}
            isMultiselect
            error={form.errors.keys}
            onChange={({ masterKey }) => {
              form.update({
                keys: masterKey,
              });
            }}
            icon={<Icon class="fas-balance-scale" />}
          />
        </FormWrapper>
      )}
    />
  );
}
